import * as React from "react"
import {Box} from "@mui/material"
import {IconSeeker, ImageSeeker} from "@ui-seeker/core"
import {isEmpty} from "@ui-seeker/utils"

import { useBuildExternalURL } from "@hooks";
import {LabelCountry} from "@components";
import {WrapperBlock} from "../../@components";
import {monitoringResultsReportIssueData} from "../../@signals";


export default function retailerColumn(monitoringTableSites, monitoringTableFilledData=false) {
    return {
        name: 'retailer', label: 'Retailer',
        options: {
            filter: false,
            sort: false,
            headerAlign: 'center',
            setCellHeaderProps: () => ({ sx: { fontWeight: 'bold' } }),
            customBodyRowRenderLite: (_, { rowPrices, winners, withRestocked, sitesFirstMovers, withOOS }) => {
                return <Box>
                    {monitoringTableSites?.map(siteID =>
                        <SingleRetailerCell
                            key={siteID}
                            siteID={siteID}
                            rowPrices={rowPrices}
                            winners={winners}
                            withRestocked={withRestocked}
                            sitesFirstMovers={sitesFirstMovers}
                            withOOS={withOOS}
                            filledData={monitoringTableFilledData}
                        />
                    )}
                </Box>
            }
        }
    }
}

const SingleRetailerCell = ({ siteID, rowPrices, winners=[], withRestocked=[], sitesFirstMovers=[], withOOS=[], filledData=false }) => {
    const { retailer, country, productID, skuID, sku, prices={} } = rowPrices[siteID] || {}
    if (!retailer)
        return <></>

    if (!filledData && isEmpty(prices))
        return <></>

	const { productURL } = useBuildExternalURL({
		siteData: { siteID, productID }
	})

    return <WrapperBlock sx={{ justifyContent: 'flex-start', fontWeight: 'normal', alignItems: 'center', gap: .5 }}>
        <ImageSeeker
            src={`/logos/website_ico_${siteID}.png`}
            width={16}
            height={16}
            alt={retailer}
        />

        <LabelCountry
            country={null}
            label={retailer}
			url={productURL ? `${productURL}?id_sku=${skuID}` : ''}
        />

        <IconSeeker
            icon='bug'
            tooltip='Report Issue'
            sx={{ fontSize: '0.68rem', color: '#f1c40f', opacity: 0.6, cursor: 'pointer' }}
            onClick={e => {
                monitoringResultsReportIssueData.value = {
                    retailer: retailer,
                    sku: sku,
                    skuID: skuID,
                    siteID: siteID,
                    country: country
                }
            }}
        />
        { sitesFirstMovers.includes(siteID) && <IconSeeker icon='chart-fft' tooltip='First Mover' sx={{ fontSize: '0.68rem' }} /> }
        { winners.includes(siteID) && <IconSeeker icon='trophy' tooltip='Most Products priced below' sx={{ fontSize: '0.68rem' }} /> }
        { withRestocked.includes(siteID) && <IconSeeker icon='arrows-repeat' tooltip='Has Restocked' sx={{ fontSize: '0.68rem' }} /> }
        { withOOS.includes(siteID) && <IconSeeker icon='arrow-right-from-bracket' tooltip='Has Out of Stock' sx={{ fontSize: '0.68rem' }} /> }
    </WrapperBlock>
}